// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { DirectMessageBase } from './DirectMessageBase.ts'
import { DirectMessageCode } from './DirectMessageCodes.ts';

export let DirectPortfolioInvestorMessage = function ()
{
    DirectMessageBase.call(this, DirectMessageCode.CODE_PORTFOLIO_INVESTOR)

    this.PortfolioSystemID = null;           // PFixIntField FIELD_PORTFOLIO_SYSTEM_ID = new PFixIntField(727); - идентификатор портфолио системы
    this.ModelID = null;                     // PFixIntField FIELD_PORTFOLIO_MODEL_ID = new PFixIntField(728); - идентификатор модели назначенной системе
    this.AccountID = null;                   // PFixIntField FIELD_ACCOUNT_ID = new PFixIntField(89); - аккаунт ID инвестора
    this.StatusOut = null;                   // PFixIntField FIELD_STATUS = new PFixIntField(708); - 0 инвестор в системе, если 1 - значит произошла отписка аккаунтом инвестора от портфолио системы
}

DirectPortfolioInvestorMessage.prototype = Object.create(DirectMessageBase.prototype)

DirectPortfolioInvestorMessage.prototype.IsSubscribed = function ()
{
    return this.StatusOut === 0
}